/**
 * useLocationSelection Composable
 * Simple adapter for location selection
 * Delegates all business logic to store actions
 * Compatible with Vue 2
 */

/**
 * Composable for managing location selection
 * @param {Object} store - Vuex store instance
 * @returns {Object} Location selection methods
 */
export function useLocationSelection(store) {
  if (!store) {
    console.warn("useLocationSelection: Store instance is required");
    return {
      selectLocation: async () => ({ requiresConfirmation: false }),
      confirmLocationChange: async () => {}
    };
  }

  /**
   * Selects a location (may require confirmation if cart has items)
   * @param {Object} location - Location object to select
   * @returns {Promise<Object>} { requiresConfirmation: boolean, newLocation }
   */
  async function selectLocation(location) {
    const storeAlias = store.getters.getStoreAlias;
    return await store.dispatch("store/changeLocation", {
      newLocation: location,
      storeAlias
    });
  }

  /**
   * Confirms and executes location change (after user confirmation)
   * @param {Object} location - Location object to select
   */
  async function confirmLocationChange(location) {
    const storeAlias = store.getters.getStoreAlias;
    await store.dispatch("store/executeLocationChange", {
      newLocation: location,
      storeAlias
    });
  }

  return {
    selectLocation,
    confirmLocationChange
  };
}
